import React from "react";

import { useSelector } from "react-redux";

import { Button, SecondaryButton, DeleteButton } from "components/Form/Button";

import { IntegrationBusinessPermission } from "constants/permissions";

import { hasPermission } from "lib/permissions";

import {
  getIntegrationBusinessById,
  getIntegrationBusinessesByTypeByBusinessId,
} from "selectors";

interface FooterProps {
  integrationBusinessId?: number | null;
  businessId?: string;
  integrationCredentialType?: string;
  createNew: () => void;
  onClickUnlink: () => void;
  onClose: () => void;
  hasFeaturePermission?: boolean;
}

export function Footer({
  businessId,
  integrationBusinessId,
  onClose,
  integrationCredentialType,
  createNew,
  onClickUnlink,
  hasFeaturePermission,
}: FooterProps) {
  const canEditIntegrationBusiness = useSelector((state: State) =>
    integrationBusinessId
      ? hasPermission(
          getIntegrationBusinessById(integrationBusinessId)(state) || {},
          IntegrationBusinessPermission.update,
        )
      : false,
  );

  const existingIntegrationBusinesses = useSelector(
    getIntegrationBusinessesByTypeByBusinessId(
      integrationCredentialType,
      businessId,
    ),
  );

  const isExistingIntegrationBusiness = Boolean(
    existingIntegrationBusinesses.find(
      integrationBusiness => integrationBusiness.id === integrationBusinessId,
    ),
  );

  const isLinkEnabled =
    hasFeaturePermission &&
    canEditIntegrationBusiness &&
    !isExistingIntegrationBusiness &&
    existingIntegrationBusinesses.length === 0;

  const isCreateEnabled =
    hasFeaturePermission && !existingIntegrationBusinesses.length;

  const isUnlinkEnabled =
    hasFeaturePermission &&
    canEditIntegrationBusiness &&
    isExistingIntegrationBusiness;

  return (
    <>
      <SecondaryButton type="button" onClick={onClose}>
        Close
      </SecondaryButton>

      <Button type="button" onClick={createNew} disabled={!isCreateEnabled}>
        Create in {integrationCredentialType}
      </Button>

      {isUnlinkEnabled ? (
        <DeleteButton type="button" onClick={onClickUnlink}>
          Unlink Business
        </DeleteButton>
      ) : (
        <Button type="submit" disabled={!isLinkEnabled}>
          Link to Business
        </Button>
      )}
    </>
  );
}
